import styled from 'styled-components'

type TypeHead={
    text?:string
    color?: string;
}

const InformationPage = styled.p`
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #999999; 
    margin-left: 22px;
    @media (max-width: ${props => props.theme.breakpoints.md}){
      margin-top: 2px;
      margin-left: 1.5rem;
    }
`
const OrderPage = styled.p<TypeHead>`
    margin: "0px 5px 0px 0px";
    font-family: Open Sans;
    font-weight: bold;
    font-size: 16px;
    color: #999999;
      @media (max-width: ${props => props.theme.breakpoints.md}){
        font-size: 12px;
        color: #222222;
        margin: 0px 0px 0px 25px;
    }  
`

const ContainerOrderPage = styled.div<TypeHead>`
    margin-left: auto;
    display: flex;
    margin-right: 30px;
    align-items:center;
      @media (max-width: ${props => props.theme.breakpoints.md}){
         margin-top: -50px;   
    }  
`

const SelectOrderPage = styled.select<TypeHead>`
    border: none;
    background-color: white;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #999999;
    margin: 0px 3px;
    /* margin-top: 2px; */
    font-family: Open Sans;
      @media (max-width: ${props => props.theme.breakpoints.md}){
         width: 90px;
         height: 30px;
         font-size: 12px;
         background-color: transparent;
         color: #222222;
    }  
`

const ContainerGeneralOrderPage = styled.div<TypeHead>`
      display: flex;
      margin-top: 30px;
      @media (max-width: ${props => props.theme.breakpoints.md}){
        display: block;
        margin-bottom: 20px;
      }  
`

export {InformationPage, OrderPage, ContainerOrderPage, SelectOrderPage, ContainerGeneralOrderPage}